// ============================================================
// FYUNOR — US Formatting Utilities
// Shared currency, percentage, number, and date formatters for
// US calculator definitions (where no locale context is available).
// ============================================================

import { CURRENCY, US_LOCALE } from "./constants";

/** Format a number as US currency, e.g. "$54,000". */
export function formatUSD(value, decimals = 0) {
  return new Intl.NumberFormat(US_LOCALE, {
    style: "currency",
    currency: CURRENCY,
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(Number.isFinite(value) ? value : 0);
}

/** Format a percentage number (77.4 means 77.4%), e.g. "77%". */
export function formatPercent(value, decimals = 1) {
  return new Intl.NumberFormat(US_LOCALE, {
    style: "percent",
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format((Number.isFinite(value) ? value : 0) / 100);
}

/** Format a plain number with grouping, e.g. "1,234.5". */
export function formatNumber(value, decimals = 0) {
  return new Intl.NumberFormat(US_LOCALE, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(Number.isFinite(value) ? value : 0);
}

/** Format a date, e.g. "Jan 1, 2035". Accepts a Date or date string. */
export function formatDate(date, style = "medium") {
  const d = date instanceof Date ? date : new Date(date);
  return new Intl.DateTimeFormat(US_LOCALE, { dateStyle: style }).format(d);
}